import { useMemo } from 'react'

/**
 * Custom hook for processing forms with enhanced questions and sorting
 */
export const useProcessedForms = (forms) => {
    return useMemo(() => {
        const enhancedForms = forms.map((form) => {
            if (!form?.questions) return form

            return {
                ...form,
                questions: [
                    ...form.questions,
                    // Add privacy policy question
                    {
                        privacy: true,
                        privacyUrl: form.privacy_policy_url,
                        facebookUrl: 'https://www.facebook.com/privacy/policies/data_privacy_framework',
                    },
                    // Add thank you page
                    {
                        thankyou: true,
                    },
                ],
            }
        })

        // Sort by creation date (newest first)
        return enhancedForms.sort((a, b) => new Date(b.created_time) - new Date(a.created_time))
    }, [forms])
}
